import ApiService from '@zola-helpers/client/dist/es/http/api';
import type { WCmsPageEntityView } from '@zola/svc-web-api-ts-client';
import { toastsActions } from '@zola-helpers/client/dist/es/redux/toasts';
import type { GenericEntityType } from 'actions/types/website/EntityActionTypes';
import { TRAVEL_TYPES, ENTITY_TYPES } from 'actions/website/EntityActions';
import { handleDeleteEventErrors } from 'actions/EventActions';
import { AppDispatch } from 'reducers/index';
import { ActivePageStateType } from '../context';

export const reorderEntities = (
  entityIds: number[],
  pageId: number
): Promise<WCmsPageEntityView[]> =>
  ApiService.post<WCmsPageEntityView[]>('/web-api/v1/cms/page/pages/list/reorder', {
    entityIds,
    pageId,
  });

type NonNullable<T> = Exclude<T, null | undefined>;

export const deleteEntity = (
  entity: GenericEntityType,
  activePage: NonNullable<ActivePageStateType>,
  appDispatch: AppDispatch
): Promise<void> => {
  const requestBody = {
    entityId: entity.id,
    pageId: activePage.id,
  };
  let entityType: string;
  if (activePage.type === 'TRAVEL') {
    const { type } = entity;
    if (type) {
      entityType = TRAVEL_TYPES[type];
    }
  } else if (activePage.type === 'PHOTO') {
    const { image_id } = entity;
    entityType = image_id ? 'Photo' : 'Video';
  } else if (activePage.type) {
    entityType = ENTITY_TYPES[activePage.type];
  }
  return ApiService.post('/web-api/v2/cms/entity/delete', requestBody)
    .then(response => {
      if (activePage.type === 'EVENT' && entity.uuid) {
        handleDeleteEventErrors(response, entity.uuid, appDispatch);
      }
    })
    .then(() => {
      appDispatch(toastsActions.positive({ headline: `${entityType} removed` }));
    });
};
